
import { useToast } from "vue-toastification";
/**
 * NOTE: If you are using other transition them make sure to import it in `src/@core/scss/vue/libs/notification.scss` from it's source
 */

export function toastSuccess(message) {

  const toast = useToast();
  toast.success(message, {
    timeout: 3000
  });

  return { toast }
}

export function toastFailure(message) {

  const toast = useToast();
  toast.error(message, {
    timeout: 3000
  });

  return { toast }
}
